module.exports = __webpack_public_path__ + "media/images/mobile/abouts/19-eefb9615862b9e2552089a455c91461d.png";